import { render } from "./OssUpload.vue?vue&type=template&id=d44a00a4&scoped=true&ts=true"
import script from "./OssUpload.vue?vue&type=script&lang=ts"
export * from "./OssUpload.vue?vue&type=script&lang=ts"

import "./OssUpload.vue?vue&type=style&index=0&id=d44a00a4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d44a00a4"]])

export default __exports__